import { Routes } from '@angular/router';
import { authGuard } from './auth/guards/auth.guard';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then(m => m.authRoutes)
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./dashboard/dashboard.component').then(c => c.DashboardComponent)
      },
      {
        path: 'convives',
        loadChildren: () => import('./convives/convives.routes').then(m => m.convivesRoutes)
      },
      {
        path: 'menus',
        loadChildren: () => import('./menus/menus.routes').then(m => m.menusRoutes)
      },
      {
        path: 'commandes',
        loadChildren: () => import('./commandes/commandes.routes').then(m => m.commandesRoutes)
      },
      {
        path: 'prefacturation',
        loadChildren: () => import('./prefacturation/prefacturation.routes').then(m => m.prefacturationRoutes)
      },
      {
        path: 'reports',
        loadChildren: () => import('./reports/reports.routes').then(m => m.reportsRoutes)
      },
      {
        path: 'settings',
        loadChildren: () => import('./settings/settings.routes').then(m => m.settingsRoutes)
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/auth/login'
  }
];
